const AMCaptcha = require('./recaptcha');

module.exports = {
  data() {
    return {
      initialFields: {},
      fields: {},
      errors: {},
      hapiformID: "",
      integrationScriptUrl: "",
      integrationDataFormat: "FormData",
      statusCode: "",
      redirectTo: "",
      busy: false,
      files: [],
      filepond: "",

      // recaptcha variables
      recaptchaDisabled: false,
      recaptchaTheme: "light",
      recaptchaError: "",
      amCaptcha: Object
    };
  },
  methods: {
    genEndpoint(){
      if(this.endpoint){
        return this.endpoint;
      }

      // no endpoint, must provide hapiform ID
      if(this.hapiformID.length===0){
        console.error("No hapiform ID provided!");
        throw new Error("No hapiform ID provided!");
      }      
      return `https://hapiform.sg/api/${this.hapiformID}`;
    },
    submit() {
      if (!this.recaptchaDisabled) {
        // enabled captcha
        this.verifyRecaptcha()
          .then(() => {
            this.formSubmission();
          })
          .catch((error) => {
            console.warn("⚠️ " + error);
            this.recaptchaError = error;
            // failed method
            this.onFailed(error);
          })
          .finally(() => {
            this.amCaptcha.reset();
          });
      } else {
        // disabled captcha
        this.formSubmission();
      }
    },
    async verifyRecaptcha() {
      // 1. get response of recaptcha
      const token = this.amCaptcha.getResponse();
      if (token.length === 0) {
        this.recaptchaError = "You can't leave Captcha Code empty";
        throw "You can't leave Captcha Code empty";
      }
      // 2. verify recaptcha
      return await this.amCaptcha.verifyRecaptcha(token)
        .then((data) => {
          if (data.success === false) {
            throw "captcha invalid: timeout or duplicate.";
          }
        });
    },
    formSubmission() {
      this.errors = {};
      this.statusCode = "";
      this.recaptchaError = "";
      this.busy = true;

      // Get all form fields
      let formData = new FormData();

      let fieldNames = Object.keys(this.fields);

      // Append all fields to formData
      fieldNames.forEach((field, i) => {
        if (typeof this.fields[field] === "object") {
          this.fields[field].forEach((item, index) => {
            formData.append(`${field}[${index}]`, item);
          });
        } else {
          formData.append(field, this.fields[field]);
        }
      });

      // Check if filepond is enabled
      if (this.filepondInstance) {
        this.filepondInstance.getFiles().forEach((file, i) => {
          formData.append(`files[${i}]`, file.file, file.name);
        });
      }

      // Check if normal file upload is enabled
      else if (this.files.length) {
        let fileList = this.files;

        for (let i = 0; i < fileList.length; i++) {
          formData.append(`files[${i}]`, fileList[i], fileList[i].name);
        }
      }

      // Append x_origin to formData
      let currentUrl = new URL(window.top.location.href);
      formData.append("x_origin", currentUrl.origin + currentUrl.pathname);

      const object = {};
      formData.forEach((value, key) => object[key] = value);
      let formDataJsonString = JSON.stringify(object);

      fetch(this.newEndpoint, {
        method: 'post', body: formDataJsonString,
        headers: {'Accept': 'application/json', 'Content-Type': 'application/json'},
      })
        .then((response) => {
          // Set the status code from the response
          this.statusCode = response.status;
          return {data: response.json(), status: response.status};
        })
        .then((res) => {
          if (this.statusCode === 201) {
            // on success webhook begin
            if (this.integrationScriptUrl.length > 0) {
              const data = this.integrationDataFormat === 'FormData' ? formData : formDataJsonString;
              this.integrationWebhook(data);
            }
            // on success webhook end

            // If the redirectTo exists, and it's a function, call it
            if (typeof this.redirectTo === "function") {
              this.redirectTo();
            }
            // Otherwise, $router.push to the path if not empty
            else if (this.redirectTo.length > 0) {
              this.$router.push(this.redirectTo);
            }

            // Clear the fields
            this.resetFields();

            // Emit the event
            this.$emit("hapi:success", res);

            // success method
            this.onSuccess(res);

            // Clear the files
            this.clearFiles();

            if (!this.recaptchaDisabled) {
              // at the end you need to reset recaptcha
              this.amCaptcha.reset();
            }
          } else if (this.statusCode === 422) {
            // {data: Promise, status: 422}
            res.data
              .then((data) => {
                // check & display error messages
                if (data.errors) {
                  // Assign the errors from the response
                  this.errors = data.errors;
                  console.warn('⚠️ form data invalid: ', JSON.stringify(data.errors));
                  // Emit the event
                  this.$emit("hapi:error", data.errors);

                  // failed method
                  this.onFailed(data.errors);

                }
              });
          } else {
            // other errors
            // like 466, domain errors
            console.error('⚠️  statusCode: ', this.statusCode, 'Response: ', res);
            // Emit the event
            this.$emit("hapi:error", res);
            // failed method
            this.onFailed(res);
          }
        })
        .catch((err) => {
          console.log("❌ err", err);
          // failed method
          this.onFailed(err);
        })
        .finally(() => {
          if (!this.recaptchaDisabled) {
            this.amCaptcha.reset();
          }
          this.busy = false;
        });
    },
    handleFiles(e) {
      this.files = e.target.files;
    },
    integrationWebhook(payload) {
      if (window.location.hostname !== "localhost" && window.location.hostname !== "127.0.0.1") {
        const headers = new Headers();
        if (payload instanceof FormData) {
          if(this.files.length > 0) {
            headers.append('Content-Type', 'multipart/form-data');
          }else{
            headers.append('Content-Type', 'application/x-www-form-urlencoded');
          }          
        } else {
          headers.append('Accept', 'application/json');
          headers.append('Content-Type', 'application/json');
        }
        fetch(this.integrationScriptUrl, {
          method: 'post', body: payload, headers: headers
        });
        fetch(this.integrationScriptUrl, {
          method: 'post', body: payload
        });
      }
    },
    clearFiles() {
      this.clearInputFiles();
      this.clearFilepondFiles();
    },
    clearInputFiles() {
      try {
        this.files = [];
        this.$refs.files.value = null;
      } catch (e) {
        // console.warn(
        //   `Adding ref="files" on the file input markup is required in order to enable auto clear the files after submitted.`
        // );
      }
    },
    clearFilepondFiles() {
      try {
        this.filepondInstance.removeFiles();
      } catch (e) {
      }
    },
    resetFields() {
      this.fields = Object.assign({}, this.initialFields);
    },
    onSuccess(res) {
    },
    onFailed(res) {
    },
  },
  computed: {
    newEndpoint() {
      let url = new URL(this.genEndpoint());

      if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
        url.searchParams.set("test", 1);
      }

      if (this.$i18n) {
        url.searchParams.set("locale", this.$i18n.locale);
      }

      return url.href;
    },
    filepondInstance() {
      return this.filepond ? this.$refs[this.filepond] : null;
    },
  },
  mounted() {
    // recaptcha init / render methods
    if (this.recaptchaDisabled === false) {
      console.info("❕ reCAPTCHA is enabled");
      let recaptcha_el = this.$el.querySelector('[recaptcha-el]');
      if (recaptcha_el) {
        this.amCaptcha = new AMCaptcha({theme: this.recaptchaTheme, render_element_or_id: recaptcha_el});
        this.amCaptcha.render();
      } else {
        this.recaptchaError = "Can't find recaptcha rendering element.";
        throw this.recaptchaError;
      }
    } else {
      console.info("❕ reCAPTCHA is disabled");
    }
    // end of recaptcha init / render methods


    this.initialFields = Object.assign({}, this.fields);

    // Display redirect path
    if (typeof this.redirectTo !== "function" && this.redirectTo.length) {
      let endpoint = new URL(this.genEndpoint());
      if (endpoint.host === "hapiform.sg") {
        console.log("🚀 " + window.location.origin + this.redirectTo);
      }
    }
    // Display the endpoint
    let endpoint = new URL(this.genEndpoint());
    let uuid = this.genEndpoint().match(/[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}/);

    if (endpoint.host === "hapiform.sg") {
      console.log(`🚀 ${endpoint.origin}/${uuid}`);
    }
  },
  watch: {
    busy(value) {
      let buttons = this.$el.querySelectorAll('form button, form input[type="submit"], form input[type="button"]');

      if (value) {
        buttons.forEach((button) => {
          button.disabled = true;
        });
      } else {
        buttons.forEach((button) => {
          button.disabled = false;
        });
      }
    },
  },
};
